function showSlides(slideClassName, dotClassName, index = 0) {
  const slides = document.getElementsByClassName(slideClassName),
    dots = document.getElementsByClassName(dotClassName);

  if (slides.length > 0 && dots.length > 0) {
    for (let i = 0; i < slides.length; i++) {
      slides[i].style.display = 'none';
    }

    if (++index > slides.length) index = 1;

    for (let i = 0; i < dots.length; i++) {
      dots[i].classList.remove('active');
    }

    slides[index - 1].style.display = 'block';
    dots[index - 1].classList.add('active');

    setTimeout(() => {
      showSlides(slideClassName, dotClassName, index);
    }, 4000); // Change image every 4 seconds according to setting
  }
}
showSlides('emi-partners', 'dot1');
showSlides('dashboard-illustration', 'dot2');
